/* ============
 * Stats Transformer
 * ============
 *
 * The transformer for the customer stats.
 */

import Transformer from '../transformer';

export default class CusotmerStats extends Transformer {
  static fetch(stat) {
    return {
      averageRatingFromStudentToCustomer: stat.average_feedback_rating_from_student_to_customer,
      averageRatingFromCustomerToStudentPop: stat.average_feedback_rating_from_customer_to_student_pop,
      averageRatingFromCustomerToStudent: stat.average_feedback_rating_from_customer_to_student,
      customerId: stat.id,
      presenceRate: stat.presence_rate,
      missionCount: stat.mission_count,
      studentCount: stat.student_count,
      studentsKpi: {
        nbStudentsToRate: stat.count_students_to_give_feedback,
        nbStudentsToValidate: stat.count_students_to_validate,
      },
      averageTimeToStaff: stat.average_time_to_staff,
      restaffedStudentCount: stat.restaffed_student_count,
      studentBriefedCount: stat.student_briefed_count,
      studentParity: stat.student_parity,
      backupActivatedCount: stat.backup_activated_count,
      nbQuoteToValidate: stat.count_quote_to_validate,
      nbContractsToSign: stat.count_contracts_to_sign,
      subAccountsKpi: (stat.children || []).map((child) => ({
        customerId: child.id,
        nbStudentsToValidate: child.count_students_to_validate,
        nbStudentsToRate: child.count_students_to_give_feedback,
      })),
    };
  }
}
